(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', './colors', './colorClasses', './fonts/fonts', './themes', './typography'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('./colors'), require('./colorClasses'), require('./fonts/fonts'), require('./themes'), require('./typography'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.colors, global.colorClasses, global.fonts, global.themes, global.typography);
    global.index = mod.exports;
  }
})(this, function (exports, _colors, _colorClasses, _fonts, _themes, _typography) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.typography = exports.themes = exports.fonts = exports.colorClasses = exports.colors = undefined;

  var _colors2 = _interopRequireDefault(_colors);

  var _colorClasses2 = _interopRequireDefault(_colorClasses);

  var fonts = _interopRequireWildcard(_fonts);

  var themes = _interopRequireWildcard(_themes);

  var typography = _interopRequireWildcard(_typography);

  function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
      return obj;
    } else {
      var newObj = {};

      if (obj != null) {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
      }

      newObj.default = obj;
      return newObj;
    }
  }

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  exports.colors = _colors2.default;
  exports.colorClasses = _colorClasses2.default;
  exports.fonts = fonts;
  exports.themes = themes;
  exports.typography = typography;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/@peachjar/components/build/styles/index.js
// module id = 72
// module chunks = 1